import { render } from "./Feature-Startup.vue?vue&type=template&id=0a4eadd2&scoped=true"
import script from "./Feature-Startup.vue?vue&type=script&lang=js"
export * from "./Feature-Startup.vue?vue&type=script&lang=js"

import "./Feature-Startup.vue?vue&type=style&index=0&id=0a4eadd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4eadd2"]])

export default __exports__